export default "__VITE_ASSET__f9a831b4__"